import { Module, GetterTree, MutationTree, ActionTree } from 'vuex'
import { RootState } from '../types'
import services from '~/services'
import { ErrorLogger } from '~/plugins/errorLogger'
import { GetSettingsGroqResult } from '~/types/sanity.types'

export interface GlobalState {
  loading: boolean
  siteSettings: GetSettingsGroqResult | null
}

export const state: GlobalState = {
  loading: false,
  siteSettings: null,
}

export const getters: GetterTree<GlobalState, RootState> = {
  loading: (state) => state.loading,
  siteSettings: (state) => state.siteSettings,
}

export const mutations: MutationTree<GlobalState> = {
  SET_LOADING: (state: GlobalState, loading: boolean) => {
    state.loading = loading
  },
  SET_SETTINGS: (state: GlobalState, siteSettings: any) => {
    state.siteSettings = siteSettings
  },
}

export const actions: ActionTree<GlobalState, RootState> = {
  getSiteSettings({ commit }) {
    commit('SET_LOADING', true)
    services.sanityService
      .getSettings({ lang: this.$i18n.locale.slice(0, 2) })
      .then((siteSettings) => {
        commit('SET_SETTINGS', siteSettings)
      })
      .catch((err) => {
        ErrorLogger.error(err)
      })
      .finally(() => {
        commit('SET_LOADING', false)
      })
  },
}

const namespaced = true

export const global: Module<GlobalState, RootState> = {
  namespaced,
  state,
  getters,
  mutations,
  actions,
}
